import { memo } from 'react';
import useProductDetailsActions from '../../hooks/useProductsDetailsActions';
import { ProductDetailsContentHeaderButtonsProps } from '../../types/productDetailsContentHeader.interfaces';
import ProductDetailsCloseButton from '../ProductDetailsCloseButton';
import { useProductDetailsContentHeaderButtonsStyles } from './ProductDetailsContentHeaderButtons.styles';

const ProductDetailsContentHeaderButtons = ({
  buttonsContainerRef,
}: ProductDetailsContentHeaderButtonsProps) => {
  const { classes } = useProductDetailsContentHeaderButtonsStyles();
  const { handleCloseModal } = useProductDetailsActions();

  return (
    <div ref={buttonsContainerRef} className={classes.container}>
      <ProductDetailsCloseButton className={classes.iconButton} onClick={handleCloseModal} />
    </div>
  );
};

export default memo(ProductDetailsContentHeaderButtons);
